import { getPredictedDate, getRemainingDays } from "./getPredictionDate";

export const sortPredictedData = (sitesData) => {
  if (!Array.isArray(sitesData) || sitesData.length === 0) {
    return [];
  }

  return [...sitesData].sort((a, b) => {
    const predictedDateA = getPredictedDate(
      a.operationalFrom,
      a.averageUsageDays
    );

    const predictedDateB = getPredictedDate(
      b.operationalFrom,
      b.averageUsageDays
    );

    const remainingDaysA = getRemainingDays(predictedDateA);
    const remainingDaysB = getRemainingDays(predictedDateB);

    // null values always go to the end
    if (remainingDaysA === null && remainingDaysB === null) {
      return 0;
    }

    if (remainingDaysA === null) {
      return 1;
    }

    if (remainingDaysB === null) {
      return -1;
    }

    // Ascending order
    return remainingDaysA - remainingDaysB;
  });
};